import { Color } from '@genial/design-tokens';
import { useFlagsStatus } from '@unleash/proxy-client-react';
import { View } from 'native-base';
import React, { useMemo } from 'react';
import { ActivityIndicator, StyleSheet } from 'react-native';
import { useRecoilValue } from 'recoil';

import { isSignedIn } from '../store/session/selector';

import { SignedIn } from './SignedIn';
import { SignedOut } from './SignedOut';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export const Routes = () => {
  const { flagsReady } = useFlagsStatus();
  const userSignedIn = useRecoilValue(isSignedIn);

  const waitComponent = useMemo(
    () => (
      <View style={styles.container}>
        <ActivityIndicator size="large" color={Color['brand.primary.principal']} />
      </View>
    ),
    []
  );

  return <>{flagsReady ? userSignedIn ? <SignedIn /> : <SignedOut /> : waitComponent}</>;
};
